// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
/** Sources are platform-owned handlers, never client-provided collection names. */
export const EVIDENCE_REPORT_SOURCE_KINDS = [
    'dpia',
    'transfer_assessment',
    'processing_activity',
    'system',
    'vendor',
    'consent',
    'consent_evidence',
    'rights_request',
    'incident',
    'form_instance',
    'attachment',
    'evidence',
];
export const EVIDENCE_REPORT_PURPOSES = [
    'internal_readiness',
    'authority_request',
    'processing_assessment',
    'transfer_assessment',
    'dossier_update',
];
//# sourceMappingURL=evidence-report.js.map